import { Temporal } from 'temporal-polyfill';
import type { ScheduledPayment } from '@/api/schemas';

export type PaymentState = 'Paid' | 'Scheduled' | 'Pending' | 'Overdue';

export function paymentState(
  payment: Pick<ScheduledPayment, 'status' | 'dueDate'>,
  today: Temporal.PlainDate,
): PaymentState {
  switch (payment.status) {
    case 'Paid':
      return 'Paid';
    case 'Scheduled':
      return 'Scheduled';
    case 'Pending':
      return Temporal.PlainDate.compare(payment.dueDate, today) < 0
        ? 'Overdue'
        : 'Pending';
  }
}

export function nextPayment(
  payments: readonly ScheduledPayment[],
  today: Temporal.PlainDate,
): ScheduledPayment | null {
  return (
    payments.find((payment) => {
      const state = paymentState(payment, today);
      return state === 'Scheduled' || state === 'Pending';
    }) ?? null
  );
}

export function paymentCommission(payment: ScheduledPayment): {
  amount: number;
  currency: string;
} {
  const cents = payment.lines.reduce(
    (sum, line) => sum + Math.round(line.markupAmount.amount * 100),
    0,
  );

  return { amount: cents / 100, currency: payment.amount.currency };
}
